const LOCAL_MASK = '*****'
const DOMAIN_MASK = '****'
const MIN_LOCAL_LENGTH_FOR_SUFFIX = 3
const LOCAL_SUFFIX_LENGTH = 2

export const maskEmail = (email: string): string => {
  const [local, domain] = email.split('@')

  if (!local || !domain) {
    return email
  }

  const [domainName, ...suffixParts] = domain.split('.')
  const suffix = suffixParts.join('.')

  const maskedLocal =
    local.length > MIN_LOCAL_LENGTH_FOR_SUFFIX
      ? `${local[0]}${LOCAL_MASK}${local.slice(-LOCAL_SUFFIX_LENGTH)}`
      : `${local[0]}${LOCAL_MASK}`

  const maskedDomain = domainName ? `${domainName[0]}${DOMAIN_MASK}` : domain
  const suffixPart = suffix ? `.${suffix}` : ''

  return `${maskedLocal}@${maskedDomain}${suffixPart}`
}
